import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    salaryAdjustmentList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    salaryAdjustmentDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const salaryAdjustmentSlice = createSlice({
  name: 'salaryAdjustment',
  initialState,
  reducers: {
    getSalaryAdjustmentList: (state, action) => {
        state.salaryAdjustmentList.requesting = true;
        state.salaryAdjustmentList.error = null;
        state.salaryAdjustmentList.items = [];
        state.salaryAdjustmentList.success = false;
        state.salaryAdjustmentList.filters = action.payload;
    },
    getSalaryAdjustmentListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.salaryAdjustmentList.requesting = false;        
        state.salaryAdjustmentList.items = data;
        state.salaryAdjustmentList.success = true; 
        state.salaryAdjustmentList.pagination.current_page = current_page;
        state.salaryAdjustmentList.pagination.per_page = per_page;
        state.salaryAdjustmentList.pagination.total = total;
    },
    getSalaryAdjustmentListFail: (state, action) => {        
        state.salaryAdjustmentList.requesting = false;
        state.salaryAdjustmentList.error = action.payload;
    },
    getSalaryAdjustmentDetails: (state) => {
        state.salaryAdjustmentDetails.requesting = true;
        state.salaryAdjustmentDetails.error = null;
        state.salaryAdjustmentDetails.data = null;
        state.salaryAdjustmentDetails.success = false; 
    },
    getSalaryAdjustmentDetailsSuccess: (state, action) => {
        state.salaryAdjustmentDetails.requesting = false;
        state.salaryAdjustmentDetails.data = action.payload;
        state.salaryAdjustmentDetails.success = true; 
    },
    getSalaryAdjustmentDetailsFail: (state, action) => {        
        state.salaryAdjustmentDetails.requesting = false;
        state.salaryAdjustmentDetails.error = action.payload;
    },
    doSalaryAdjustmentCreate: (state) => {
        state.salaryAdjustmentDetails.requesting = true;
        state.salaryAdjustmentDetails.error = null;
        state.salaryAdjustmentDetails.data = null;
        state.salaryAdjustmentDetails.success = false; 
    },
    doSalaryAdjustmentUpdate: (state) => {
        state.salaryAdjustmentDetails.requesting = true;
        state.salaryAdjustmentDetails.error = null;
        state.salaryAdjustmentDetails.data = null;
        state.salaryAdjustmentDetails.success = false; 
    },
    doSalaryAdjustmentDelete: (state) => {
        state.salaryAdjustmentDetails.requesting = true;
        state.salaryAdjustmentDetails.error = null;
        state.salaryAdjustmentDetails.data = null;
        state.salaryAdjustmentDetails.success = false; 
    },
  },
})

export const { 
    getSalaryAdjustmentList, getSalaryAdjustmentListSuccess, getSalaryAdjustmentListFail,
    getSalaryAdjustmentDetails, getSalaryAdjustmentDetailsSuccess, getSalaryAdjustmentDetailsFail,
    doSalaryAdjustmentCreate, doSalaryAdjustmentUpdate, doSalaryAdjustmentDelete
} = salaryAdjustmentSlice.actions

export default salaryAdjustmentSlice.reducer